import VersionInfoDialogContainer from './containers/VersionInfoDialogContainer';

export default VersionInfoDialogContainer;
